document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".single-play-btn").forEach((button) => {
    button.addEventListener("click", function (ev) {
      const singlePlayBtn = button;
      singlePlayBtn.classList.add("no-disp");
      const imageBlock = singlePlayBtn.closest(".yummy__image-block");
      const imagePart = singlePlayBtn.closest(".yummy__image_part");
      const videoCover = imageBlock.querySelector(".single-video-covers");
      const closeVideo = imageBlock.querySelector(".close-single-video");
      const videoPadding = document.querySelector(".video_padding");

      videoCover ? (videoCover.style.display = "none") : null;

      closeVideo?.classList.remove("no-disp");
      imagePart?.classList.add("rel");
      document.body.classList.add("no-scroll");
      videoPadding?.classList.add("no-disp");

      if (imageBlock?.classList.contains("single-custom-video")) {
        const customVideo = imageBlock.querySelector(".single-cust-video");
        customVideo?.classList.remove("no-disp");
        customVideo?.play();
        imagePart?.classList.add("full-screen");
      } else {
        const ytVideo = imageBlock?.querySelector(".single-yt-video");
        const id = ytVideo?.getAttribute("id");
        ytVideo?.classList.remove("no-disp");

        const symbol = ytVideo.src.indexOf("?") > -1 ? "&" : "?";
        ytVideo.src += symbol + "enablejsapi=1&rel=0&muted=0&autoplay=1";

        if (singlePlayBtn.getAttribute("data-type") === "vimeo") {
          const player = document.getElementById(id).contentWindow;
          player.postMessage(JSON.stringify({ method: "play", value: 0 }), "*");
          setTimeout(function () {
            player.postMessage(JSON.stringify({ method: "setCurrentTime", value: 1 }), "*");
          }, 1000);
        } else {
          document
            .getElementById(id)
            .contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
        }

        imagePart.classList.add("full-screen");
      }
    });
  });

  document.querySelectorAll(".close-single-video").forEach((button) => {
    button.addEventListener("click", function (ev) {
      const mainDiv = button.closest(".yummy__image_part");
      mainDiv.classList.remove("full-screen");
      if (mainDiv.querySelector(".single-video-covers")) {
        mainDiv.querySelector(".single-video-covers").style.display = "block";
      }

      mainDiv.querySelector(".single-play-btn")?.classList.remove("no-disp");

      mainDiv.querySelector(".single-yt-video").classList.add("no-disp");
      mainDiv.querySelector(".close-single-video").classList.add("no-disp");
      document.querySelectorAll(".yummy__image_part").forEach((el) => el.classList.remove("rel"));
      document.body.classList.remove("no-scroll");
      document.querySelector(".video_padding").classList.remove("no-disp");

      const imageBlock = button.closest(".yummy__image-block");
      if (imageBlock.classList.contains("single-custom-video")) {
        const customVideo = imageBlock.querySelector(".single-cust-video");
        customVideo.classList.add("no-disp");
        customVideo.pause();
      } else {
        const ytVideo = mainDiv.querySelector(".single-yt-video");
        const symbol = ytVideo.src.indexOf("?") > -1 ? "&" : "?";
        ytVideo.src += symbol + "rel=0";
        ytVideo.contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', "*");
      }
    });
  });

  if (!customElements.get("custom-accordion")) {
    customElements.define(
      "custom-accordion",
      class CustomAccordion extends HTMLElement {
        constructor() {
          super();
          this.accordionButtons = this.querySelectorAll("[data-accordion-button]");
          this.accordionContents = this.querySelectorAll("[data-accordion-content]");
          this.handleAccordionClick = this.handleAccordionClick.bind(this);

          this.accordionButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
              this.handleAccordionClick(button);
            });
          });
        }

        connectedCallback() {}

        handleAccordionClick(button) {
          try {
            const selectedAccordion = button.nextElementSibling;
            this.accordionButtons.forEach((el) => {
              el.nextElementSibling.style.height = "";
            });

            if (button.classList.contains("active")) {
              button.classList.remove("active");
            } else {
              this.accordionButtons.forEach((el) => {
                el.classList.remove("active");
              });
              button.classList.add("active");
              selectedAccordion.style.height = selectedAccordion.scrollHeight + "px";
            }
          } catch (error) {
            console.log(error);
          }
        }
      }
    );
  }

  function main_spacing() {
    if (window.innerWidth <= 768) {
      document.querySelector("main").style.marginTop = "0px";
    }
  }
  main_spacing();

  window.addEventListener("load", function () {
    main_spacing();
    document
      .querySelector(".shopify-section-yg-cart-drawer#shopify-section-yg-cart-drawer")
      ?.classList.remove("hidden");
  });

  window.addEventListener("resize", function () {
    main_spacing();
    document
      .querySelector(".shopify-section-yg-cart-drawer#shopify-section-yg-cart-drawer")
      ?.classList.remove("hidden");
  });

  window.addEventListener("scroll", function () {
    setTimeout(function () {
      if (window.scrollY === 0) {
        main_spacing();
      }
    }, 100);
  });

  document.querySelectorAll(".Mobile_mega_menu.first-open").forEach((el) => {
    el.addEventListener("click", function () {
      el.classList.remove("first-open");
    });
  });

  window.addEventListener("resize", function () {
    const windowWidth = window.innerWidth;
    const menuDrawerOpen = document.querySelectorAll("#menu-drawer .mega-menu[open]").length;
    const inlineMenuOpen = document.querySelectorAll(".header__inline-menu .mega-menu[open]").length;
    const mainElement = document.querySelector("main");
    const headerElement = document.querySelector(".header");

    if (windowWidth <= 991) {
      if (menuDrawerOpen === 0) {
        mainElement.classList.remove("open_megamenu");
        headerElement.classList.remove("header-background-color");
      } else {
        mainElement.classList.add("open_megamenu");
        headerElement.classList.add("header-background-color");
      }
    } else {
      if (inlineMenuOpen === 0) {
        mainElement.classList.remove("open_megamenu");
        headerElement.classList.remove("header-background-color");
      } else {
        mainElement.classList.add("open_megamenu");
        headerElement.classList.add("header-background-color");
      }
    }
  });
});
